export default __webpack_public_path__ + "static/media/logo.f00719fd.svg";